/* Shipping Protection engine: keeps exactly one correct protection line in the cart and renders the widget. */
(function () {
  var core = window.ShippingProtectionCore;
  var cfgEl = document.getElementById('shipping-protection-config');
  if (!core || !cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg) return; // enabled:false still runs: plan() then removes any leftover protection line

  var SELF = 'X-Shipping-Protection';
  var nativeFetch = window.fetch.bind(window);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var queue = Promise.resolve();
  var pending = false;
  var last = null; // last plan, used for rendering
  var busy = false;
  var inflight = []; // theme/app cart mutations still waiting for a response
  var checkoutPending = false;
  var GUARD_TIMEOUT_MS = cfg.guardTimeoutMs || 4000;
  var QUIET_MS = 300; // the theme reads cart.js, then sends its change a beat later
  var activity = 0;   // theme cart requests seen (reads and writes)

  function country() {
    return (window.Shopify && window.Shopify.country) || null;
  }

  function rate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r && r > 0 ? r : 1;
  }

  function cartRequest(path, body) {
    var init = { credentials: 'same-origin', headers: {} };
    init.headers[SELF] = '1';
    if (body) {
      init.method = 'POST';
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(body);
    }
    return nativeFetch(root + path, init).then(function (res) {
      if (!res.ok) throw new Error('cart request failed: ' + path + ' ' + res.status);
      return res.json();
    });
  }

  function reconcile() {
    busy = true;
    return cartRequest('cart.js').then(function (cart) {
      var p = core.plan(cart, cfg, { now: new Date().toISOString(), rate: rate(), country: country() });
      if (!p.changed) return { cart: cart, plan: p, mutated: false };
      var body = {};
      if (Object.keys(p.updates).length) body.updates = p.updates;
      if (Object.keys(p.attributes).length) body.attributes = p.attributes;
      return cartRequest('cart/update.js', body).then(function (newCart) {
        return { cart: newCart, plan: core.plan(newCart, cfg, { now: new Date().toISOString(), rate: rate(), country: country() }), mutated: !!body.updates };
      });
    }).then(function (r) {
      last = r.plan;
      busy = false;
      render();
      fixCounts(r.cart, r.plan);
      if (r.mutated && !r.plan.changed) afterLineChange();
    }).catch(function (err) {
      // Fail open: hide the widget, never block the cart.
      console.warn('[shipping-protection]', err);
      last = { state: 'hidden' };
      busy = false;
      render();
    });
  }

  function schedule() {
    if (pending) return queue;
    pending = true;
    queue = queue.then(function () {
      return new Promise(function (r) { setTimeout(r, 50); });
    }).then(function () {
      pending = false;
      return reconcile();
    });
    return queue;
  }

  function setChoice(on) {
    busy = true;
    render();
    var attrs = {};
    attrs[core.ATTR] = on ? 'Added' : 'Declined';
    attrs[core.DISCLOSURE_ATTR] = core.disclosure(cfg, new Date().toISOString());
    queue = queue.then(function () {
      return cartRequest('cart/update.js', { attributes: attrs });
    }).catch(function (err) { console.warn('[shipping-protection]', err); });
    pending = false; // an already-queued reconcile runs before this write; queue one after it
    return schedule();
  }

  function onCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function afterLineChange() {
    if (onCartPage()) {
      if (!checkoutPending) reloadCartPage();
      return;
    }
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
  }

  // Backstop: never reload more than twice in 10 seconds.
  function reloadCartPage() {
    try {
      var key = 'shipping-protection-reloads';
      var now = Date.now();
      var recent = JSON.parse(window.sessionStorage.getItem(key) || '[]').filter(function (t) { return now - t < 10000; });
      if (recent.length >= 2) return;
      recent.push(now);
      window.sessionStorage.setItem(key, JSON.stringify(recent));
    } catch (e) { /* storage unavailable: still reload once */ }
    window.location.reload();
  }

  function fixCounts(cart, plan) {
    var count = Math.max(0, cart.item_count - (plan.protectionQty || 0));
    document.querySelectorAll('[data-js-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency })
        .format((cents * rate()) / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  // Static shield mark (no user input) for the widget.
  var SHIELD_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M12 2.8 4.5 5.6v5.9c0 4.6 3.1 8.2 7.5 9.7 4.4-1.5 7.5-5.1 7.5-9.7V5.6L12 2.8Z"/>' +
    '<path d="m8.6 12 2.4 2.4 4.4-4.6"/></svg>';

  function icon(name) {
    var tpl = document.getElementById('shipping-protection-icons');
    var el = tpl && tpl.content.querySelector('[data-icon="' + name + '"]');
    return el ? el.innerHTML : '';
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function renderSlot(slot) {
    if (!last || last.state === 'hidden') { slot.hidden = true; slot.innerHTML = ''; return; }
    var copy = cfg.copy || {};
    var required = last.state === 'required';
    slot.hidden = false;
    slot.innerHTML = '';

    var box = el('div', 'shipping-protection' + (required ? ' shipping-protection--required' : '') + (last.checked ? ' shipping-protection--on' : ''));
    var accent = /^#[0-9a-f]{6}$/i.test(cfg.accentColor || '') ? cfg.accentColor : '#111111';
    if (box.style) {
      box.style.setProperty('--sp-accent', accent);
      box.style.setProperty('--sp-accent-contrast', core.contrastColor(accent));
    }
    box.setAttribute('aria-busy', busy ? 'true' : 'false');
    var row = el('label', 'shipping-protection__row');
    var input = el('input', 'shipping-protection__checkbox');
    input.type = 'checkbox';
    input.setAttribute('data-protection-toggle', '');
    input.checked = !!last.checked;
    input.disabled = required || busy;
    var visual = el('span', 'shipping-protection__check-visual');
    visual.setAttribute('aria-hidden', 'true');
    visual.innerHTML = icon('check');
    var pkg = el('span', 'shipping-protection__icon');
    pkg.setAttribute('aria-hidden', 'true');
    pkg.innerHTML = SHIELD_SVG;
    var text = el('span', 'shipping-protection__text');
    text.appendChild(el('span', 'shipping-protection__title ff-body fs-body-75', copy.title || 'Shipping Protection'));
    var subtitle = el('span', 'shipping-protection__subtitle ff-body fs-body-50 t-subdued',
      core.fillAmount(required ? (copy.requiredLabel || 'Required for orders {amount}+') : (copy.subtitle || ''), cfg.requiredThresholdCents));
    text.appendChild(subtitle);
    var price = el('span', 'shipping-protection__price ff-body fs-body-75', money(last.tier.feeCents));
    row.appendChild(input); row.appendChild(visual); row.appendChild(pkg); row.appendChild(text); row.appendChild(price);
    box.appendChild(row);

    var learn = null;
    if (copy.learnMoreUrl) {
      learn = el('a', 'shipping-protection__learn', copy.learnMoreLabel || 'Learn more');
      learn.href = copy.learnMoreUrl; // same tab, like every other link on the site
    }
    // Compact: the link sits inline at the end of the notice, or of the subtitle when protected.
    if (!last.checked && copy.declinedNotice) {
      var notice = el('p', 'shipping-protection__notice ff-body', core.fillAmount(copy.declinedNotice, cfg.requiredThresholdCents));
      if (learn) { notice.appendChild(document.createTextNode ? document.createTextNode(' ') : el('span', '', ' ')); notice.appendChild(learn); }
      box.appendChild(notice);
    } else if (learn) {
      subtitle.appendChild(document.createTextNode ? document.createTextNode(' ') : el('span', '', ' '));
      subtitle.appendChild(learn);
    }
    slot.appendChild(box);
  }

  function render() {
    document.querySelectorAll('[data-protection-slot]').forEach(renderSlot);
  }

  // Theme re-renders cart sections (cart page, popup) and replaces our slot with an empty one.
  var raf = 0;
  new MutationObserver(function () {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      var empty = Array.prototype.some.call(document.querySelectorAll('[data-protection-slot]'), function (s) {
        return !s.firstChild && last && last.state !== 'hidden';
      });
      if (empty) render();
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Any cart mutation made by the theme or another app triggers a reconcile.
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CART_ACTIVITY = /\/cart(\.js|\/(add|change|update|clear))/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var headers = (init && init.headers) || {};
    var self = typeof headers.get === 'function' ? headers.get(SELF) : headers[SELF];
    var res = nativeFetch(input, init);
    if (!self && CART_ACTIVITY.test(url)) activity++;
    if (!self && CART_MUTATION.test(url)) {
      inflight.push(res);
      var done = function () { inflight.splice(inflight.indexOf(res), 1); };
      res.then(done, done);
      res.then(schedule, function () {});
    }
    return res;
  };

  function waitForInflight() {
    return Promise.all(inflight.map(function (p) { return p.then(null, function () {}); }));
  }

  // Settled = nothing in flight, reconciled, and no new theme cart request for QUIET_MS.
  function settleForCheckout() {
    var seen = activity;
    return waitForInflight().then(schedule).then(function () {
      return new Promise(function (r) { setTimeout(r, QUIET_MS); });
    }).then(function () {
      if (inflight.length || activity !== seen) return settleForCheckout();
    });
  }
  ['cart:updated', 'cart:item-added', 'apps:product-added-to-cart'].forEach(function (name) {
    document.addEventListener(name, function () { schedule(); });
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-protection-toggle]')) setChoice(t.checked);
  });

  // Checkout guard: make sure the cart is reconciled before leaving for checkout.
  document.addEventListener('submit', function (e) {
    var btn = e.submitter;
    var form = e.target;
    if (!btn || btn.name !== 'checkout') return;
    if (form.getAttribute('data-protection-verified') === '1') { form.removeAttribute('data-protection-verified'); return; }
    e.preventDefault();
    checkoutPending = true;
    var verified = settleForCheckout();
    var timeout = new Promise(function (r) { setTimeout(r, GUARD_TIMEOUT_MS); });
    Promise.race([verified, timeout]).then(function () {
      var target = form;
      var submitter = btn;
      // The theme may have re-rendered the cart meanwhile; a detached form can't submit.
      if (form.isConnected === false) {
        var all = Array.prototype.slice.call(document.querySelectorAll('button[name="checkout"], input[name="checkout"]'));
        var fresh = all.filter(function (b) { return b.className === btn.className; })[0] || all[0] || document.querySelector('button[name="checkout"], input[name="checkout"]');
        target = fresh && fresh.form && fresh.form.isConnected !== false ? fresh.form : null;
        submitter = fresh;
      }
      setTimeout(function () { checkoutPending = false; }, 8000);
      if (!target) { window.location.assign('/checkout'); return; }
      target.setAttribute('data-protection-verified', '1');
      if (target.requestSubmit) target.requestSubmit(submitter); else submitter.click();
    });
  }, true);

  window.ShippingProtection = { refresh: schedule };
  schedule();
})();
